'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchSubscription = exports.SWITCH_SUBSCRIPTION = exports.ERROR_NO_PAYMENT_SOURCE = exports.LEAVING_PAGE_FLAG = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.doSwitchSubscription = doSwitchSubscription;
exports.watchPlanConfirmationModalSagas = watchPlanConfirmationModalSagas;

var _effects = require('redux-saga/effects');

var _sagaTools = require('@classpass/saga-tools');

var _reactRouterRedux = require('react-router-redux');

var _helpers = require('redux/saga/helpers');

var _deep = require('helpers/deep');

var _multitrack = require('helpers/multitrack');

var _bound = require('redux/saga/entities/bound');

var _page = require('redux/modules/page');

var _planChangeEffectiveDates = require('constants/plan-change-effective-dates');

var _Banners = require('features/Banners/Banners.reducer');

var _modals = require('redux/modules/modals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doSwitchSubscription),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchPlanConfirmationModalSagas);

var LEAVING_PAGE_FLAG = exports.LEAVING_PAGE_FLAG = 'LEAVING_PAGE';
var ERROR_NO_PAYMENT_SOURCE = exports.ERROR_NO_PAYMENT_SOURCE = 4315;
var SWITCH_SUBSCRIPTION = exports.SWITCH_SUBSCRIPTION = 'PLAN_CONFIRMATION_MODAL.SWITCH_SUBSCRIPTION';

var switchSubscription = exports.switchSubscription = function switchSubscription(subscriptionData) {
  return { type: SWITCH_SUBSCRIPTION, subscriptionData: subscriptionData };
};

function doSwitchSubscription(client, _ref) {
  var subscriptionData = _ref.subscriptionData;

  var newPlanId, effective, _subscriptionData$tra, trackingData, userId, _ref2, _ref3, currentSubscription, newPlan, activeLocation;

  return _regenerator2.default.wrap(function doSwitchSubscription$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          newPlanId = subscriptionData.newPlanId, effective = subscriptionData.effective, _subscriptionData$tra = subscriptionData.trackingData, trackingData = _subscriptionData$tra === undefined ? {} : _subscriptionData$tra;
          _context.next = 4;
          return (0, _effects.call)(_helpers.getUserId);

        case 4:
          userId = _context.sent;
          _context.next = 7;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.subscription, [client, userId]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.planById, [client, newPlanId]), (0, _effects.call)(_helpers.getUserLocation, client), (0, _effects.put)((0, _page.toggleFlag)(LEAVING_PAGE_FLAG))]);

        case 7:
          _ref2 = _context.sent;
          _ref3 = (0, _slicedToArray3.default)(_ref2, 3);
          currentSubscription = _ref3[0].current_subscription;
          newPlan = _ref3[1];
          activeLocation = _ref3[2];
          _context.next = 14;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.createSubscription, [client, {
            userId: userId,
            msaId: newPlan.msa_id,
            planId: newPlan.id,
            effective: effective || _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE,
            locationId: (0, _deep.deepExtract)('location.id', activeLocation)
          }]);

        case 14:
          _context.next = 16;
          return (0, _effects.call)(_multitrack.ec, 'Manage Membership - Complete', (0, _extends3.default)({
            page_type: 'plan_switching',
            action: 'confirm_plan',
            pending_plan_id: newPlan.id,
            pending_plan_code: newPlan.plan_code,
            current_plan_id: currentSubscription.plan.id,
            current_plan_code: currentSubscription.plan.plan_code,
            plan_change_type: effective
          }, trackingData));

        case 16:
          _context.next = 18;
          return (0, _effects.all)([(0, _effects.put)((0, _modals.hideModal)('PlanConfirmationModal')), (0, _effects.put)((0, _Banners.addSuccessNotification)('Success! Your plan change has been confirmed.', {
            removeAfterNavigations: 2,
            timeout: 0
          })), (0, _effects.put)((0, _reactRouterRedux.replace)('/settings/membership'))]);

        case 18:
          _context.next = 24;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context['catch'](0);
          _context.next = 24;
          return (0, _effects.put)((0, _page.toggleFlag)(LEAVING_PAGE_FLAG));

        case 24:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 20]]);
}

function watchPlanConfirmationModalSagas(client) {
  return _regenerator2.default.wrap(function watchPlanConfirmationModalSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, switchSubscription().type, doSwitchSubscription, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}